import React, { Component, Fragment } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';

import config from '../../config';
import styles from './SignUpPage.css';

class SignUpPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };

    state = {
        townNames: [],
        town: '',
        name: '',
        email: '',
        error: '',
        nameError: '',
        townError: '',
        done: false,
    };

    componentDidMount() {
        fetch(`${config.backend}/papers/towns/names`)
            .then(res => res.json())
            .then(townNames => this.setState({ townNames }));
    }

    handleUpdateTown = town => {
        this.setState({ town, townError: '' });
    };

    handleUpdateName = (e, name) => {
        this.setState({ name, nameError: '' });
    };

    handleChangeEmail = (e, email) => {
        this.setState({ email, error: '' });
    };

    handleRegisterClick = () => {
        const { email, town: townName, name } = this.state;
        const {
            intl: { locale, formatMessage },
        } = this.props;

        let ok = true;

        if (!townName) {
            this.setState({ townError: formatMessage({ id: 'SignUpPage.Fill in town name' }) });
            ok = false;
        }

        if (!name) {
            this.setState({ nameError: formatMessage({ id: 'SignUpPage.Fill in name' }) });
            ok = false;
        }

        if (!/.+@.+\..+/.test(email)) {
            this.setState({ error: formatMessage({ id: 'SignUpPage.Wrong email' }) });
            ok = false;
        }

        if (!ok) {
            return;
        }

        fetch(`${config.backend}/papers/users`, {
            method: 'POST',
            body: JSON.stringify({ email, townName, language: locale, name }),
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
        })
            .then(res => {
                if (res.ok) {
                    this.setState({ done: true });
                } else {
                    this.setState({ error: formatMessage({ id: 'SignUpPage.Cannot register' }) });
                }
            })
            .catch(() => this.setState({ error: formatMessage({ id: 'SignUpPage.Cannot register' }) }));
    };

    handleKeyDown = e => {
        if (e.which === 13) {
            this.handleRegisterClick();
        }
    };

    renderDone() {
        return (
            <p className={styles.success}>
                <FormattedMessage id="SignUpPage.Email sent" values={{ email: <b>{this.state.email}</b> }} />
            </p>
        );
    }

    render() {
        const {
            intl: { formatMessage },
        } = this.props;

        if (this.state.done) {
            return this.renderDone();
        }

        return (
            <Fragment>
                <FormattedMessage id="SignUpPage.You need to register" />
                <br />
                <span className={styles.subtitle}>
                    <FormattedMessage id="SignUpPage.Already registered?" />
                    <Link to="/signin">
                        <FormattedMessage id="SignUpPage.Sign in" />
                    </Link>
                </span>
                <TextField
                    value={this.state.name}
                    onChange={this.handleUpdateName}
                    floatingLabelText={formatMessage({ id: 'SignUpPage.name' })}
                    fullWidth
                    errorText={this.state.nameError}
                    errorStyle={{ float: 'left' }}
                    onKeyDown={this.handleKeyDown}
                />
                <AutoComplete
                    searchText={this.state.town}
                    dataSource={this.state.townNames}
                    onUpdateInput={this.handleUpdateTown}
                    floatingLabelText={formatMessage({ id: 'SignUpPage.town' })}
                    fullWidth
                    errorText={this.state.townError}
                    errorStyle={{ float: 'left' }}
                    onKeyDown={this.handleKeyDown}
                />
                <TextField
                    value={this.state.email}
                    onChange={this.handleChangeEmail}
                    floatingLabelText={formatMessage({ id: 'SignUpPage.email' })}
                    fullWidth
                    errorText={this.state.error}
                    errorStyle={{ float: 'left' }}
                    onKeyDown={this.handleKeyDown}
                />
                <RaisedButton
                    label={formatMessage({ id: 'SignUpPage.register' })}
                    primary={true}
                    className={styles.button}
                    onClick={this.handleRegisterClick}
                />
            </Fragment>
        );
    }
}

export default injectIntl(SignUpPage);



// WEBPACK FOOTER //
// ./src/Pages/SignUpPage/SignUpPage.js